import * as React from 'react';

interface Props {
    for?: string;
    labelText: React.ReactNode;
    children?: React.ReactNode;
}

export class QuestionLabel extends React.Component<Props> {
    public render() {
        return (
            <label className="question-label" htmlFor={this.props.for}>
                    {this.props.labelText}
                <div className="question-control">
                    {this.props.children}
                </div>
            </label>
        )
    }
}